<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Bulk {{ isAdd ? 'Add' : 'Remove' }} Customers {{ isAdd ? 'To' : 'From' }} Challenge</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <ng-container *ngIf="!loadingSave">
      <div class="form-group">
        <label for="challengeInput">Challenge</label>
        <select class="custom-select" id="challengeInput" name="challengeInput"
                [(ngModel)]="selectedChallenge"
                [disabled]="loadingChallenges || (challengeList.length === 0)">
          <option *ngFor="let challenge of challengeList"
                  [ngValue]="challenge">
            {{ challenge.name }}
          </option>
          <option *ngIf="loadingChallenges"
                  [ngValue]="null"
                  selected>
            Loading...
          </option>
          <option *ngIf="!loadingChallenges && (challengeList.length === 0)"
                  [ngValue]="null"
                  selected>
            No active challenges are available
          </option>
        </select>
      </div>
    </ng-container>

    <ng-container class="modal-body" *ngIf="loadingSave">
      <h4>Loading...</h4>

      <div class="progress">
        <div class="progress-bar" role="progressbar" [style]="{width: getLoadingProgressPercentageStr() + '%'}"
             attr.aria-valuenow="{{ getLoadingProgressPercentageStr() }}" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
    </ng-container>

    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            [disabled]="!saveButtonEnabled()"
            [class.disabled]="!saveButtonEnabled()"
            (click)="handleSubmit()">
      {{ loadingSave ? 'Loading...' : 'Save' }}
    </button>
  </div>

</ng-container>
